module.exports = __webpack_public_path__ + "media/images/Signatures_About-p-500-f784bd94b683053554530c8647711aee.jpeg";